import axios from "axios";

const ENDPOINT = "users";

export default {
  async retrieveUsers({ commit }) {
    try {
      const {
        data: {
          data: { users },
        },
      } = await axios.get(`${ENDPOINT}/`);
      commit("SET_USERS", users);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async updateUser({ commit }, userUpdated) {
    try {
      const {
        data: {
          data: { user },
        },
      } = await axios.put(`${ENDPOINT}/update/${userUpdated.uid}`, userUpdated);
      commit("SET_USER", user);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async retrieveUser({ commit }, userUid) {
    try {
      const {
        data: {
          data: { user },
        },
      } = await axios.get(`${ENDPOINT}/${userUid}`);
      commit("SET_USER_ITEM", user);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },
};
